import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const BASE_URL = 'https://newalemny.3almny.app/api';

// جلب سجل الاختبارات
export const fetchExamHistory = createAsyncThunk(
  'examHistory/fetchExamHistory',
  async (subjectId = 0, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem('token3almny');
      const response = await fetch(`${BASE_URL}/tests/student_entered_tests/${subjectId}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      const data = await response.json();
      if (!response.ok) {
        return rejectWithValue(data.message || 'فشل جلب سجل الاختبارات');
      }
      // ✅ الداتا الحقيقية في result.data
      return data.result?.data || [];
    } catch (error) {
      return rejectWithValue(error.message || 'فشل جلب سجل الاختبارات');
    }
  }
);

// جلب تفاصيل إجابات الطالب
export const fetchExamAnswers = createAsyncThunk(
  'examHistory/fetchExamAnswers',
  async (testId, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem('token3almny');
      const response = await fetch(`${BASE_URL}/tests/my_answers/${testId}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      const data = await response.json();
      if (!response.ok) {
        return rejectWithValue(data.message || 'فشل جلب تفاصيل الإجابات');
      }
      return data.result || [];
    } catch (error) {
      return rejectWithValue(error.message || 'فشل جلب تفاصيل الإجابات');
    }
  }
);

const initialState = {
  history: [],
  answers: [],
  loading: false,
  error: null,
};

const examHistorySlice = createSlice({
  name: 'examHistory',
  initialState,
  reducers: {
    clearExamHistory: (state) => {
      state.history = [];
      state.answers = [];
      state.loading = false;
      state.error = null;
    },
    clearExamAnswers: (state) => {
      state.answers = [];
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchExamHistory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchExamHistory.fulfilled, (state, action) => {
        state.loading = false;
        state.history = action.payload;
      })
      .addCase(fetchExamHistory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchExamAnswers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchExamAnswers.fulfilled, (state, action) => {
        state.loading = false;
        state.answers = action.payload;
      })
      .addCase(fetchExamAnswers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearExamHistory, clearExamAnswers } = examHistorySlice.actions;
export default examHistorySlice.reducer;